import { useLocation, useRouteMatch } from 'react-router-dom';

const useCurrentPathName = (): string => {
  const { pathname } = useLocation();
  const { url } = useRouteMatch();
  return pathname === url ? pathname.replace('/', '') : pathname.replace(url, '').split('/')[1];
};

export default useCurrentPathName;
